import React from 'react';
import Modal from '../../components/Modal';

const PaymentSuccessModal = ({ phone, onClose }) => {
  const body = (
    <div className="h-72 flex flex-col justify-center items-center text-center space-y-4 px-4">
      <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center">
        <svg
          className="w-10 h-10 text-green-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <h3 className="text-lg font-semibold text-green-700">Ödəniş uğurla tamamlandı!</h3>
      <p className="text-sm text-gray-600 leading-relaxed">
        Biletiniz e-mail ünvanınıza göndərildi. Zəhmət olmasa <strong>inbox</strong> və <strong>spam</strong> qovluğunuzu yoxlayın. <br />
        Əgər hər hansı səbəbdən bilet sizə çatmayıbsa, zəhmət olmasa <strong className="text-black">{phone}</strong> nömrəsi ilə əlaqə saxlayın.
      </p>
    </div>
  );

  return (
    <Modal
      title=""
      body={body}
      buttons={
        <button
          onClick={() => onClose(false)}
          type="button"
          className="mt-3 inline-flex justify-center rounded-md bg-black px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-gray-700 sm:mt-0 sm:w-auto"
        >
          Bağla
        </button>
      }
    />
  );
};

export default PaymentSuccessModal;
